import { render, staticRenderFns } from "./risk-based-quality.vue?vue&type=template&id=d56ccf68&scoped=true&"
import script from "./risk-based-quality.vue?vue&type=script&lang=js&"
export * from "./risk-based-quality.vue?vue&type=script&lang=js&"
import style0 from "./risk-based-quality.vue?vue&type=style&index=0&id=d56ccf68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56ccf68",
  null
  
)

component.options.__file = "risk-based-quality.vue"
export default component.exports